var map = {
	"./foundation_login_logo.png": 88844,
	"./hetu_login_logo.png": 17920,
	"./hn_login_logo.png": 60789,
	"./ship-login-logo.png": 13952,
	"./sunward-login-bg.png": 75564,
	"./sunward-login-logo.png": 31897,
	"./xa_login_logo.png": 58401,
	"./xgd_login_logo.png": 55822
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 41701;